import React from 'react';
import { Search, X } from 'lucide-react';

const SearchForm = ({
  searchTerm,
  handleInputChange,
  handleSearchSubmit,
  clearSearch,
  autocompleteResults,
  showAutocomplete,
  handleAutocompleteClick,
  inputRef,
  autocompleteRef,
  setShowAutocomplete,
  highlightEnabled,
  setHighlightEnabled,
  placeholder,
  highlightText,
}) => {
  return (
    <div className="relative max-w-xl mb-2">
      <form onSubmit={handleSearchSubmit} className="flex gap-2">
        <div className="flex-1 relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input
            ref={inputRef}
            type="text"
            className="block w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md leading-5 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder={placeholder}
            value={searchTerm}
            onChange={handleInputChange}
            onClick={() => {
              if (searchTerm && searchTerm.length >= 2) {
                setShowAutocomplete(true);
              }
            }}
          />
          {searchTerm && (
            <button
              type="button"
              className="absolute inset-y-0 right-0 pr-3 flex items-center"
              onClick={clearSearch}
            >
              <X className="h-5 w-5 text-gray-400 hover:text-gray-500" />
            </button>
          )}
        </div>
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          Search
        </button>
        <button
          type="button"
          onClick={() => setHighlightEnabled(!highlightEnabled)}
          className={`px-3 py-2 rounded-md text-sm font-medium ${highlightEnabled
              ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
        >
          Highlight {highlightEnabled ? 'On' : 'Off'}
        </button>
      </form>

      {showAutocomplete && (
        <div
          ref={autocompleteRef}
          className="absolute z-10 w-full bg-white mt-1 rounded-md shadow-lg max-h-60 overflow-auto"
        >
          <ul className="py-1">
            {autocompleteResults.map((suggestion, index) => (
              <li
                key={index}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleAutocompleteClick(suggestion)}
              >
                <div className="flex justify-between items-center">
                  <span className="truncate">
                    {suggestion.type === 'Gene Name' || suggestion.entityType === 'gene' ? (
                      <span className="italic">
                        {highlightText(suggestion.text, searchTerm, true)}
                      </span>
                    ) : (
                      highlightText(suggestion.text, searchTerm, true)
                    )}
                  </span>
                  <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full ml-2 flex-shrink-0">
                    {suggestion.type}
                  </span>
                </div>
                {suggestion.description && (
                  <div className="text-xs text-gray-500 mt-1 truncate">
                    {suggestion.description}
                  </div>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SearchForm;